import { onMounted, onUnmounted, ref } from 'vue'

export function useTheme() {
  const theme = ref('default')

  onMounted(() => {
    if (process.client) {
      theme.value = document.documentElement.getAttribute('theme') || 'default'

      const observer = new MutationObserver(() => {
        theme.value = document.documentElement.getAttribute('theme') || 'default'
      })

      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['theme'] })

      onUnmounted(() => {
        observer.disconnect()
      })
    }
  })

  return theme
}
